import useGet from './use-get'
import { DiscoverPage } from '@beatgig/api/discover-page'
import { ConfigInterface } from 'swr'
import { DiscoverSection } from '@beatgig/api-services'

export default function useDiscoverPage(
  options?: ConfigInterface<DiscoverSection[]>
) {
  return useGet(
    () => {
      return 'discover-page'
    },
    () => DiscoverPage.get(),
    options
  )
}
